/**
 * Apply the same DOM masking as `PhiMask` for nodes outside React trees
 * (for example `<title>` and `<meta>` injected by Next.js metadata).
 */
export function applyPhiMaskDomToElement(
  element: Element,
  options?: { maskPosthog?: boolean; maskLocalize?: boolean },
): void {
  const maskPosthog = options?.maskPosthog ?? true
  const maskLocalize = options?.maskLocalize ?? true
  if (maskPosthog) {
    element.classList.add('ph-no-capture')
  }
  if (maskLocalize) {
    element.classList.add('notranslate')
    element.setAttribute('notranslate', '')
    element.setAttribute('translate', 'no')
  }
}
